import { type FunctionComponent, type ReactElement } from 'react'
import dynamic from 'next/dynamic'
import HbbGoogleMaps from '@/components/ui/GoogleMaps/Hbb'
import WifiGoogleMaps from '@/components/ui/GoogleMaps/networkCoverage'
import TravelPointsGoogleMaps from '@/components/ui/GoogleMaps/travelPoints'
import { IMG_URL } from '@/utils/constants'
import useIntl from '@/utils/intl'
import { TAB_ID } from '@/lib/network-coverage-v2/networkCoverageConstants'
import { type MapState } from '@/lib/network-coverage-v2/types'

const OpenLayersMap = dynamic(async () => await import('@/components/ui/OpenlayersMap/networkCoverage'), { ssr: false })

interface MapSectionProps {
  activeTab: number
  mapState: MapState
  userLocation?: { lat: number, lng: number } | null
  onLocationRequest?: () => void
}

const MapSection: FunctionComponent<MapSectionProps> = ({ activeTab, mapState, userLocation, onLocationRequest }) => {
  useIntl()

  if (mapState === undefined || mapState === null) {
    return <></>
  }

  const renderMap = (): ReactElement => {
    if (activeTab === TAB_ID.NETWORK) {
      return (
        <OpenLayersMap
          kmlUrl={mapState.kmlContent}
          center={mapState.center}
          zoom={mapState.zoom}
          overlays={mapState.overlays}
          imgBaseUrl={IMG_URL}
          userLocation={userLocation}
        />
      )
    }
    if (activeTab === TAB_ID.TRAVEL) {
      return (
        <TravelPointsGoogleMaps
          zoom={mapState.selectedTravelPoint !== undefined ? 20 : 12}
          center={mapState.center}
          markers={mapState.markers ?? []}
          userLocation={userLocation}
        />
      )
    }
    if (activeTab === TAB_ID.HBB) {
      return (
        <HbbGoogleMaps
          kmlUrl={mapState.kmlHbb}
          center={mapState.center}
          zoom={mapState.zoom}
          userLocation={userLocation}
        />
      )
    }
    return (
      <WifiGoogleMaps
        kmlUrl={mapState.kmlWifi}
        center={mapState.center}
        zoom={mapState.zoom}
        userLocation={userLocation}
      />
    )
  }

  return (
    <div id='Mapsection' className='2xl:w-[65vw] w-full grayscale-10 relative'>
      <div className='2xl:h-full h-[60vh] relative'>
        {renderMap()}

      </div>
    </div>
  )
}

export default MapSection
